import { apiSlice } from "../../app/api/apiSlice";

// LC-481: Company Being Represented options (legal name + DBAs) for the
// Loan Originator's company or branch.
export const companyRepresentationApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getCompanyRepresentationOptions: builder.mutation({
			query: ({ orgId }) => ({
				url: `/api/v1/organization/${orgId}/company_representation_options/`,
				method: "GET",
			}),
		}),
	}),
});

export const { useGetCompanyRepresentationOptionsMutation } =
	companyRepresentationApiSlice;
